import { useCallback, useEffect } from 'react'
import { Navigate, useNavigate, useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import Grid from '@material-ui/core/Grid'
import Clear from '@material-ui/icons/Clear'
import { ROUTES } from '../../../../constants'
import { TCFDIVersion } from 'models/invoices.models'
import { STORE_EVENT_TYPES } from 'lib/enums/shared.enums'
import { selectActiveWorkspace } from 'lib/helpers/selectors'
import useStoreEvent from 'hooks/Shared/useStoreEvent'
import { useAppSelector } from 'store/hooks'
import { resetForm } from 'actions/forms'
import { setSelectedInvoice } from 'actions/invoices'
import AddPaymentComplementContainer from 'containers/Invoices/PaymentComplements/AddPaymentComplementContainer/AddPaymentComplementContainer'
import Button from 'components/Shared/Button/Button'
import './styles.scss'

const AddPaymentComplementScreen = () => {
  const navigate = useNavigate()
  const { invoice, version } = useParams()

  const invoiceId = Number(invoice)
  const dispatch = useDispatch()

  const workspaceId = useAppSelector(selectActiveWorkspace)

  const cleanup = useCallback(() => {
    navigate(ROUTES.INVOICES, { replace: true })
    dispatch(setSelectedInvoice())
    dispatch(resetForm('createPaymentComplement'))
  }, [dispatch, navigate])

  useStoreEvent(STORE_EVENT_TYPES.ACTIVE_WORKSPACE_CHANGE, () => cleanup())

  useEffect(
    () => () => {
      window.scrollTo(0, 0)
      cleanup()
    },
    [cleanup]
  )

  if (!invoiceId) {
    return <Navigate to={ROUTES.INVOICES} replace />
  }

  if (!workspaceId) {
    return <Navigate to={ROUTES.HOME} replace />
  }

  return (
    <>
      <Grid container spacing={0} className="screen-add-payment-complement">
        <Grid item xs={12}>
          <div className="title-container">
            <h1>Nuevo complemento de pago</h1>
            <Button
              variant="hover"
              color="secondary"
              startIcon={<Clear />}
              onClick={cleanup}>
              Cancelar
            </Button>
          </div>
        </Grid>
        <Grid item xs={12}>
          <AddPaymentComplementContainer
            invoiceId={invoiceId}
            version={version as TCFDIVersion}
            cleanup={cleanup}
          />
        </Grid>
      </Grid>
    </>
  )
}

export default AddPaymentComplementScreen
